import AppLayout from "@/layouts/AppLayout.vue";
import FaqListView from "@/views/faq/FaqListView.vue";
import FaqFormView from "@/views/faq/FaqFormView.vue";

export default [
  {
    path: '/faq',
    name: 'faqList',
    component: FaqListView,
    meta: {
      parent: 'faq',
      related: 'faqList',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_FAQ']
    }
  },
  {
    path: '/faq/create',
    name: 'faqCreate',
    component: FaqFormView,
    meta: {
      parent: 'faq',
      related: 'faqList',
      layout: AppLayout,
      requiresAuth: true,
      permissions: ['ADD_FAQ']
    }
  },
  {
    path: '/faq/:id(\\d+)/edit',
    name: 'faqEdit',
    component: FaqFormView,
    meta: {
      parent: 'faq',
      related: 'faqList',
      layout: AppLayout,
      requiresAuth: true,
      permissions: ['EDIT_FAQ']
    }
  },
];
